import { render, staticRenderFns } from "./JoinChat.vue?vue&type=template&id=a321a54e&scoped=true&"
import script from "./JoinChat.vue?vue&type=script&lang=js&"
export * from "./JoinChat.vue?vue&type=script&lang=js&"
import style0 from "./JoinChat.vue?vue&type=style&index=0&id=a321a54e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a321a54e",
  null
  
)

export default component.exports